module.exports = __webpack_public_path__ + "static/img/mfjc.36177dd.png";


//////////////////
// WEBPACK FOOTER
// ./lib/imgs/shops/mfjc.png
// module id = jOFD
// module chunks = 1